/* tslint:disable */

/**
 * Options REST API
 *
 * Access market data, manage accounts, and trade Binance Options.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @interface NewBlockTradeOrderLegsParameterInner
 */
export interface NewBlockTradeOrderLegsParameterInner {
    /**
     * Option trading pair
     * @type {string}
     * @memberof NewBlockTradeOrderLegsParameterInner
     */
    symbol: string;
    /**
     * Buy/sell direction
     * @type {string}
     * @memberof NewBlockTradeOrderLegsParameterInner
     */
    side: NewBlockTradeOrderLegsParameterInnerSideEnum;
    /**
     * Order type
     * @type {string}
     * @memberof NewBlockTradeOrderLegsParameterInner
     */
    type: NewBlockTradeOrderLegsParameterInnerTypeEnum;
    /**
     * Order quantity
     * @type {string}
     * @memberof NewBlockTradeOrderLegsParameterInner
     */
    quantity: string;
    /**
     * Order price
     * @type {string}
     * @memberof NewBlockTradeOrderLegsParameterInner
     */
    price?: string;
}

export const NewBlockTradeOrderLegsParameterInnerSideEnum = {
    BUY: 'BUY',
    SELL: 'SELL',
} as const;

export type NewBlockTradeOrderLegsParameterInnerSideEnum =
    (typeof NewBlockTradeOrderLegsParameterInnerSideEnum)[keyof typeof NewBlockTradeOrderLegsParameterInnerSideEnum];
export const NewBlockTradeOrderLegsParameterInnerTypeEnum = {
    LIMIT: 'LIMIT',
} as const;

export type NewBlockTradeOrderLegsParameterInnerTypeEnum =
    (typeof NewBlockTradeOrderLegsParameterInnerTypeEnum)[keyof typeof NewBlockTradeOrderLegsParameterInnerTypeEnum];
